module.exports = __webpack_public_path__ + "media/17.210c90f7.mp3";